module.exports = __webpack_public_path__ + "static/media/image4.18523ced.png";